import cardPainterManager from '../../../../../Widgets/DataPainterWidget/Core/CardPainterManager';
import commandEngine from './CommandEngine';
import { CMD_CONFIDENCE_REGISTRY_KEY, META_TYPE, META_VER } from './confidenceCommandRegisteryType';

/**
 * Registers the /confidence command with the CommandEngine.
 * Call once at module load from YourLibraryTab (via CommandEngine.bootup).
 *
 * /confidence — opens the ConfidenceWidget card.
 */
export function registerConfidenceCommand() {
    commandEngine.register('/confidence', {
        hint: 'Open confidence widget',
        params: [],
        handler: () => {
            cardPainterManager.openCard(CMD_CONFIDENCE_REGISTRY_KEY, { type: META_TYPE, ver: META_VER, target: 'global' });
        },
    });
}
